<template>
    <div class="wrapper-box">
        <web-header></web-header>
        <web-slide :data="data"></web-slide>
        <web-products :products="products"></web-products>
        <web-parallax></web-parallax>
        <web-footer></web-footer>
        <web-arrow-up></web-arrow-up>
    </div>
</template>
<script>
import header from "@/components/header";
import slide from "@/components/slide";
import content from "@/components/content";
import parallax from "@/components/parallax";
import footer from "@/components/footer";
import products from "@/components/categories/products";
import arrowUp from "@/components/arrowUp.vue";
import bg from "../../assets/images/categories/banners/titulo_mixroedores.jpg";
import bgMob from "../../assets/images/categories/banners/titulo_mixroedores_mobile.jpg";

import img1 from "../../assets/images/products/mixroedores_hamsters.jpg";
import img2 from "../../assets/images/products/mixroedores_cobayos.jpg";

export default {
  name: "naturalMixRoedores",
  data() {
    return {
      data: [
        {
          html:
            " <h1>NATURAL MIX ROEDORES</h1><p>Alimento a base de materias primas de primera calidad que constituye una dieta balanceada a la medida de su mascota</p>",
          style:
            "background:url(" +
            this.getBg() +
            ") no-repeat; background-size:cover;    background-position: center; height:300px; "
        }
      ],
      products: [
        {
          image: img1,
          title: "MIX HAMSTER",
          description: `El Mix para Hámster de Nelsoni Ranch, posee una selección especial de semillas y esta fortificado con extrusado  balanceado, manteniendo a su roedor vital y feliz. <br>
Se recomienda suplementar con pasturas y frutas.<br>
Ingredientes: trigo, girasol, maíz entero, sorgo, avena, con vitaminas.
 `,
          extraData: "Presentación 750 gr. y 30 kilos."
        },
        {
          image: img2,
          title: "MIX COBAYO",
          description: `El Mix para Cobayo de Nelsoni Ranch esta Especialmente formulado para diferentes variedades de cobayo. Su mayor componente es el balanceado especifico de cobayos y contiene semillas en menor cantidad, componente nutritivo y recreativo a la vez.<br>
Se recomienda incorporar en la dieta de todo cobayo frutas frescas, Heno de pasturas Nelsoni Ranch, alfalfas en cubo, rama o pellets. <br>
Ingredientes: trigo,  avena, cebada. Pellet compuestos por: cascarilla de soja, expeler de girasol, cebada, afrecho de arroz, afrecho de trigo, soja entera, alfalfa, carbonato de calcio, oligosacáridos mánanos, núcleo vitamínico ACD3E, sal.
 `,
          extraData: "Presentación 750 gr. y 30 kilos."
        }
      ]
    };
  },
  components: {
    webHeader: header,
    webSlide: slide,
    webContent: content,
    webParallax: parallax,
    webFooter: footer,
    webProducts: products,
    webArrowUp: arrowUp
  },
  methods: {
    detectmob() {
      if (window.screen.availWidth <= 800) {
        return true;
      } else {
        return false;
      }
    },
    getBg() {
      if (this.detectmob()) {
        return bgMob;
      }
      return bg;
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/components/categories/naturalMixRoedores.vue